module.exports = __webpack_public_path__ + "static/media/28-8.abd11ae0.mp3";